import List from "components/list";
import { NameCell } from "@/components/cells/name";
import { IntegrationProjectCell, PROJECT_FIELDS, projectNameSearch } from "../cells";

// All Google Drive folders across projects, from projects__integrations.
export default function DriveIntegrations({ storageKey = "integrations-drive", title = "Drive" }) {
  const columns = [
    {
      id: "project",
      header: "Project",
      accessorKey: "projects",
      cell: IntegrationProjectCell,
    },
    {
      id: "folder",
      header: "Folder",
      accessorFn: (row) => row?.item?.folder_id || "-",
      // Plain text cell; the column-level link (not an <a> in the cell) avoids nesting
      // inside the row's <Link>, and overrides the row link for this cell only.
      cell: (info) => (
        <span className="hover:underline break-all">
          <NameCell {...info} />
        </span>
      ),
      href: (row) => (row?.item?.folder_id ? `https://drive.google.com/drive/folders/${row.item.folder_id}` : false),
      linkProps: { target: "_blank", rel: "noreferrer" },
    },
  ];

  const fields = [
    "id",
    ...PROJECT_FIELDS,
    "item:integrations_drive.id",
    "item:integrations_drive.folder_id",
  ];

  return (
    <div className="w-full">
      <div className="flex-1 h-full">
        <List
          title={title}
          endPoint="projects__integrations"
          sortBy="id"
          storageKey={storageKey}
          filters={{ collection: { _eq: "integrations_drive" } }}
          columns={columns}
          meta={{ fields, customSearch: projectNameSearch }}
          searchPlaceholder="Search project"
          href={(row) => row?.item?.id && `/integrations/drive/${row.projects?.project_id}/${row.item.id}`}
        />
      </div>
    </div>
  );
}
